module.exports = __webpack_public_path__ + "static/media/plusIcon.3a177d1e.svg";